import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'

import { KVMessageDef } from './index'

export function getCursorDataMessage() {
  return {
    type: 'cursorData',
    requiredData: ['value_f'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const temperatureF = json.value_f as number

      kv.setCurrentTemperature({
        temperature: temperatureF,
      })

      kv.setTemperatureProbeLoading(false)
    },
  } as KVMessageDef
}

export function getCursorTemperatureMessage() {
  return {
    type: 'cursorTemperature',
    requiredData: ['temperatureF'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const temperatureF = json.temperatureF as number

      kv.setCurrentTemperature({
        temperature: temperatureF,
      })

      kv.setTemperatureProbeLoading(false)
    },
  } as KVMessageDef
}
